import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function LeadershipSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-116">
          Liderazgo
        </h2>
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-117">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-118">
            <div className="flex-shrink-0" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/7U3hDq8J9KthoV73FcJn55/Andreina_Escalante.jpg" alt="Andreina Escalante Prado, Fundadora" className="w-48 h-48 object-cover rounded-full shadow-lg" data-id="element-120" />
            </div>
            <div className="flex-1" data-id="element-121">
              <h3 className="text-2xl font-bold text-dark mb-2" data-id="element-122">
                Andreina Escalante Prado
              </h3>
              <p className="text-primary font-semibold mb-4" data-id="element-123">Fundadora</p>
              <p className="text-gray-600 mb-6" data-id="element-124">
                Creadora del Método VIVO, un enfoque integral que transforma la
                biología familiar a través de la educación, nutrición y acceso a
                medicina biomédica. Con años de experiencia ayudando a familias
                a navegar el neurodesarrollo, Andreina lidera la misión de hacer
                accesible el conocimiento y los recursos que cambian vidas.
              </p>
              <div className="bg-primary/5 rounded-xl p-6 border-l-4 border-primary" data-id="element-125">
                <QuoteIcon className="w-8 h-8 text-primary mb-3" data-id="element-126" />
                <p className="text-dark italic" data-id="element-127">
                  "Cada familia merece ser el superhéroe de su propia historia.
                  Nuestro trabajo es darles las herramientas para lograrlo."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}